/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddCtnRequest,
  AddressResponse,
  ApplyPromoCodeRequest,
  AuthorizeResponseModel,
  BaseCityRoutesV2Response,
  BasketItemBaseModel,
  BasketItemRequestModel,
  BasketResponseModel,
  BasketStatsResponseModel,
  BasketsMergeRequest,
  BrandsModel,
  CapacitiesModel,
  ChangeRegionRequest,
  ChangeStatusRequestModel,
  ChangeStatusResponseModel,
  CheckRequestModel,
  CheckResponseModel,
  CheckServiceTransactionResponseModel,
  ClientOperatorResponseModel,
  CountriesResponse,
  CreateOrUpdateOrderRequest,
  CreateOrUpdateOrderResponseModel,
  DataResponseModel,
  DefaultTariffResponse,
  DeliveryFastDeliveryModel,
  DeliveryFastPointMovementModel,
  DeliveryGetModel,
  DeliveryIntervalsPerDateModel,
  DeliveryOnlineDeliveryModel,
  DeliveryPointFranchiseModel,
  DeliveryPointModel,
  DeliveryPointMovementModel,
  DeliveryPvzPostomatModel,
  DeliveryRouteDeliveryModel,
  DeliveryRouteDeliveryV2Model,
  DeliveryUpdateModel,
  DeliveryUpdateOrderCommandResult,
  DeviceTypesModel,
  DigineticaRecommendationsRequestModel,
  DigineticaRecommendationsResponseModel,
  EnumerateCreditsRequestModel,
  EnumerateCreditsResponseModel,
  EnumerateProductsUpSaleRequestModel,
  EsiaDataResponseModel,
  EsiaUrlResponseModel,
  FacSubscriberSearchRequestModel,
  FacSubscriberSearchResponseModel,
  FastDeliveryCitiesResponse,
  FavouriteResponse,
  FetchCtnByRuleResponse,
  GetAddressQuery,
  GetCitiesResult,
  GetCityRoutesResponse,
  LandingUpdateRequestModel,
  MaxPriceModel,
  ModelsModel,
  NotificationBodyRequestModel,
  OperatorRequestModel,
  OrderCompleteDeferredRequest,
  OrderCompleteRequest,
  PaymentCreateTransactionResponse,
  PaymentRegisterDeferredResponse,
  PaymentRegisterResponse,
  PaymentsGetResponse,
  ProblemDetails,
  ProductInfoModel,
  ProductModel,
  PromoCodeRedemptionResponseModel,
  RegionResponseModel,
  RequestModel,
  RequestModel2,
  RequestModel3,
  RequestModel4,
  RequestModel5,
  RequestModel6,
  RequestModel7,
  RequestModel8,
  ResponseFastDeliveryStreet,
  ResponseModel,
  ResponseModel10,
  ResponseModel11,
  ResponseModel12,
  ResponseModel13,
  ResponseModel14,
  ResponseModel15,
  ResponseModel16,
  ResponseModel17,
  ResponseModel2,
  ResponseModel3,
  ResponseModel4,
  ResponseModel5,
  ResponseModel6,
  ResponseModel7,
  ResponseModel8,
  ResponseModel9,
  ResponseService,
  RouteCitiesResponse,
  SealOrderRequest,
  SealOrderResponse,
  SendTokenRequestModel,
  SendTokenRequestModel2,
  SendTokenRequestModel3,
  SendTokenResponseModel,
  SendTokenResponseModel2,
  SendTokenResponseModel3,
  ServiceInfoModel,
  StreetResponseModel,
  TariffModel,
  TariffResponseModel,
  ValidateCtnRequest,
  ValidateCtnV2Request,
  ValidateCtnV2Response,
  ValidateRequestModel,
  ValidateResponseModel,
  ValidateTokenRequestModel,
  ValidateTokenRequestModel2,
  ValidateTokenRequestModel3,
  ValidateTokenResponseModel,
  ValidateTokenResponseModel2,
  ValidateTokenResponseModel3,
  VerifyResponseModel,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

const handleSettledPromises = <T>(responses: PromiseSettledResult<T>[]) => {
  const fulfilledResponses = responses.filter(
    (data) => data.status === 'fulfilled',
  ) as PromiseFulfilledResult<T>[];
  const isAllRejected = !fulfilledResponses.length;

  if (isAllRejected) {
    throw new Error();
  }

  return fulfilledResponses.map((data) => data.value);
};

export class Api<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  static joinRequests = <T>(list: Iterable<PromiseLike<T>>) =>
    Promise.allSettled(list).then(handleSettledPromises);

  /**
   * Generates a request url for utilityGetSiteText
   */
  composeUtilityGetSiteTextUrl = () => `/api/v1/Utility/sitetext`;

  /**
   * No description
   *
   * @tags Utility
   * @name UtilityGetSiteText
   * @summary Получает значение текста из QP
   * @request GET:/api/v1/Utility/sitetext
   * @response `200` `string | null` Текст
   */
  utilityGetSiteText<T extends string | null = string | null>(
    query?: {
      /** Название текста */
      key?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeUtilityGetSiteTextUrl(),
      method: 'GET',
      query: query,
      ...params,
    });
  }

  /**
   * Generates a request url for utilityGetInfo
   */
  composeUtilityGetInfoUrl = () => `/api/v1/Utility/info`;

  /**
   * No description
   *
   * @tags Utility
   * @name UtilityGetInfo
   * @summary Возвращает информацию о версии приложения
   * @request GET:/api/v1/Utility/info
   * @response `200` `string | null` Информация о приложении
   */
  utilityGetInfo<T extends string | null = string | null>(params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeUtilityGetInfoUrl(),
      method: 'GET',
      ...params,
    });
  }

  /**
   * Generates a request url for upSaleEnumerateRecommends
   */
  composeUpSaleEnumerateRecommendsUrl = () => `/api/v1/UpSale/products/list`;

  /**
   * No description
   *
   * @tags UpSale
   * @name UpSaleEnumerateRecommends
   * @summary Получает список рекомендованных продуктов
   * @request POST:/api/v1/UpSale/products/list
   * @response `200` `void` Список продуктов
   */
  upSaleEnumerateRecommends<T extends void = void>(
    request: EnumerateProductsUpSaleRequestModel,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeUpSaleEnumerateRecommendsUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      ...params,
    });
  }

  /**
   * Generates a request url for tradeInGetModels
   */
  composeTradeInGetModelsUrl = () => `/api/v1/TradeIn/models`;

  /**
   * No description
   *
   * @tags TradeIn
   * @name TradeInGetModels
   * @summary Получает список моделей устройств
   * @request GET:/api/v1/TradeIn/models
   * @response `200` `ModelsModel` Список моделей устройств
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  tradeInGetModels<T extends ModelsModel = ModelsModel>(
    query?: {
      /** Тип устройства */
      deviceType?: string | null;
      /** Бренд */
      brand?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeTradeInGetModelsUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for tradeInGetMaxPrice
   */
  composeTradeInGetMaxPriceUrl = () => `/api/v1/TradeIn/maxprice`;

  /**
   * No description
   *
   * @tags TradeIn
   * @name TradeInGetMaxPrice
   * @summary Получает максимальную цену устройства
   * @request GET:/api/v1/TradeIn/maxprice
   * @response `200` `MaxPriceModel` Максимальная цена
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  tradeInGetMaxPrice<T extends MaxPriceModel = MaxPriceModel>(
    query?: {
      /** Тип устройства */
      deviceType?: string | null;
      /** Бренд */
      brand?: string | null;
      /** Модель */
      model?: string | null;
      /** Емкость */
      capacity?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeTradeInGetMaxPriceUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for tradeInGetDeviceTypes
   */
  composeTradeInGetDeviceTypesUrl = () => `/api/v1/TradeIn/deviceTypes`;

  /**
   * No description
   *
   * @tags TradeIn
   * @name TradeInGetDeviceTypes
   * @summary Получает типы устройств
   * @request GET:/api/v1/TradeIn/deviceTypes
   * @response `200` `DeviceTypesModel` Типы устройств
   */
  tradeInGetDeviceTypes<T extends DeviceTypesModel = DeviceTypesModel>(params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeTradeInGetDeviceTypesUrl(),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for tradeInGetCapacities
   */
  composeTradeInGetCapacitiesUrl = () => `/api/v1/TradeIn/capacities`;

  /**
   * No description
   *
   * @tags TradeIn
   * @name TradeInGetCapacities
   * @summary Получает список емкостей
   * @request GET:/api/v1/TradeIn/capacities
   * @response `200` `CapacitiesModel` Список емкостей
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  tradeInGetCapacities<T extends CapacitiesModel = CapacitiesModel>(
    query?: {
      /** Тип устройства */
      deviceType?: string | null;
      /** Бренд */
      brand?: string | null;
      /** Модель */
      model?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeTradeInGetCapacitiesUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for tradeInGetBrands
   */
  composeTradeInGetBrandsUrl = () => `/api/v1/TradeIn/brands`;

  /**
   * No description
   *
   * @tags TradeIn
   * @name TradeInGetBrands
   * @summary Получает список брендов
   * @request GET:/api/v1/TradeIn/brands
   * @response `200` `BrandsModel` Список брендов
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  tradeInGetBrands<T extends BrandsModel = BrandsModel>(
    query?: {
      /** Тип устройства */
      deviceType?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeTradeInGetBrandsUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for tokenValidateToken
   */
  composeTokenValidateTokenUrl = () => `/api/v1/Token/validateToken`;

  /**
   * No description
   *
   * @tags Token
   * @name TokenValidateToken
   * @summary Проверяет правильность токена
   * @request POST:/api/v1/Token/validateToken
   * @response `200` `ValidateTokenResponseModel` Результат проверки
   */
  tokenValidateToken<T extends ValidateTokenResponseModel = ValidateTokenResponseModel>(
    request: ValidateTokenRequestModel,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeTokenValidateTokenUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for tokenSendToken
   */
  composeTokenSendTokenUrl = () => `/api/v1/Token/sendToken`;

  /**
   * No description
   *
   * @tags Token
   * @name TokenSendToken
   * @summary Отправляет токен для проверки
   * @request POST:/api/v1/Token/sendToken
   * @response `200` `SendTokenResponseModel` Результат отправки
   */
  tokenSendToken<T extends SendTokenResponseModel = SendTokenResponseModel>(
    request: SendTokenRequestModel,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeTokenSendTokenUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for tariffsGetTariffs
   */
  composeTariffsGetTariffsUrl = () => `/api/v1/Tariffs/servicesinfo`;

  /**
   * No description
   *
   * @tags Tariffs
   * @name TariffsGetTariffs
   * @summary Получает информацию об опциях тарифов
   * @request GET:/api/v1/Tariffs/servicesinfo
   * @response `200` `(ServiceInfoModel)[]` Информация об опциях
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  tariffsGetTariffs<T extends ServiceInfoModel[] = ServiceInfoModel[]>(
    query?: {
      /** Регион */
      region?: string | null;
      /** Список опций */
      socs?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeTariffsGetTariffsUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for tariffsGetTariffs2
   */
  composeTariffsGetTariffs2Url = () => `/api/v1/Tariffs/omnibasket`;

  /**
   * No description
   *
   * @tags Tariffs
   * @name TariffsGetTariffs2
   * @summary Получает информацию о тарифах
   * @request GET:/api/v1/Tariffs/omnibasket
   * @response `200` `(TariffModel)[]` Список тарифов
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  tariffsGetTariffs2<T extends TariffModel[] = TariffModel[]>(
    query?: {
      Region?: string | null;
      /** @format int32 */
      DpcId?: number | null;
      IsMnp?: boolean | null;
      IsFamily?: boolean | null;
      IsBase?: boolean | null;
      ActiveOnly?: boolean | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeTariffsGetTariffs2Url(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for tariffsGetTariffs22
   */
  composeTariffsGetTariffs22Url = (dpcId: number) => `/api/v1/Tariffs/omnibasket/${dpcId}`;

  /**
   * No description
   *
   * @tags Tariffs
   * @name TariffsGetTariffs22
   * @summary Получает информацию о тарифе
   * @request GET:/api/v1/Tariffs/omnibasket/{dpcId}
   * @response `200` `TariffResponseModel` Тариф
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  tariffsGetTariffs22<T extends TariffResponseModel = TariffResponseModel>(
    dpcId: number,
    query?: {
      /** Регион */
      region?: string | null;
      /** Получать только активный */
      activeOnly?: boolean | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeTariffsGetTariffs22Url(dpcId),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for tariffsGetTariff
   */
  composeTariffsGetTariffUrl = () => `/api/v1/Tariffs`;

  /**
   * No description
   *
   * @tags Tariffs
   * @name TariffsGetTariff
   * @summary Получает тариф
   * @request GET:/api/v1/Tariffs
   * @response `200` `TariffModel` Тариф
   * @response `400` `ProblemDetails`
   */
  tariffsGetTariff<T extends TariffModel = TariffModel>(
    query?: {
      /**
       * Идентификатор тарифа
       * @format int32
       */
      dpcId?: number;
      /**
       * Идентификатор региона
       * @format int32
       */
      regionId?: number;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeTariffsGetTariffUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for tariffsGetTariffs23
   */
  composeTariffsGetTariffs23Url = () => `/api/v1/Tariffs/list`;

  /**
   * No description
   *
   * @tags Tariffs
   * @name TariffsGetTariffs23
   * @summary Получает список тарифов
   * @request GET:/api/v1/Tariffs/list
   * @response `200` `ResponseModel` Список тарифов
   * @response `400` `ProblemDetails`
   */
  tariffsGetTariffs23<T extends ResponseModel = ResponseModel>(
    query?: {
      /**
       * Идентификатор региона
       * @format int32
       */
      regionId?: number | null;
      /** Название региона */
      regionPath?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeTariffsGetTariffs23Url(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for regionGetCities
   */
  composeRegionGetCitiesUrl = (regionId: number, search: string) =>
    `/api/v1/Region/routeCities/${regionId}/${search}`;

  /**
   * No description
   *
   * @tags Region
   * @name RegionGetCities
   * @summary Получает информацию о городах
   * @request GET:/api/v1/Region/routeCities/{regionId}/{search}
   * @response `200` `RouteCitiesResponse` Информация о городах
   */
  regionGetCities<T extends RouteCitiesResponse = RouteCitiesResponse>(
    regionId: number,
    search: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeRegionGetCitiesUrl(regionId, search),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for regionGetByMarketCode
   */
  composeRegionGetByMarketCodeUrl = (marketCode: string) =>
    `/api/v1/Region/marketCode/${marketCode}`;

  /**
   * No description
   *
   * @tags Region
   * @name RegionGetByMarketCode
   * @summary Получает информацию о регионе
   * @request GET:/api/v1/Region/marketCode/{marketCode}
   * @response `200` `RegionResponseModel` Информация о регионе
   * @response `400` `ProblemDetails`
   */
  regionGetByMarketCode<T extends RegionResponseModel = RegionResponseModel>(
    marketCode: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeRegionGetByMarketCodeUrl(marketCode),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for regionGetById
   */
  composeRegionGetByIdUrl = (regionId: number) => `/api/v1/Region/id/${regionId}`;

  /**
   * No description
   *
   * @tags Region
   * @name RegionGetById
   * @summary Получает информацию о регионе
   * @request GET:/api/v1/Region/id/{regionId}
   * @response `200` `RegionResponseModel` Информация о регионе
   * @response `400` `ProblemDetails`
   */
  regionGetById<T extends RegionResponseModel = RegionResponseModel>(
    regionId: number,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeRegionGetByIdUrl(regionId),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for regionGetCities2
   */
  composeRegionGetCities2Url = (basketId: string, regionId: number) =>
    `/api/v1/Region/getCityRoutes/${basketId}/${regionId}`;

  /**
   * No description
   *
   * @tags Region
   * @name RegionGetCities2
   * @summary Получает список маршрутов
   * @request GET:/api/v1/Region/getCityRoutes/{basketId}/{regionId}
   * @response `200` `GetCityRoutesResponse` Список маршрутов
   * @response `204` `void` Список маршрутов
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  regionGetCities2<T extends GetCityRoutesResponse = GetCityRoutesResponse>(
    basketId: string,
    regionId: number,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeRegionGetCities2Url(basketId, regionId),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for regionEnumerateRegions
   */
  composeRegionEnumerateRegionsUrl = () => `/api/v1/Region/list`;

  /**
   * No description
   *
   * @tags Region
   * @name RegionEnumerateRegions
   * @summary Получает список регионов
   * @request GET:/api/v1/Region/list
   * @response `200` `(RegionResponseModel)[]` Список регионов
   */
  regionEnumerateRegions<T extends RegionResponseModel[] = RegionResponseModel[]>(
    query?: {
      /** Строка поиска */
      query?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeRegionEnumerateRegionsUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for regionGetCountries
   */
  composeRegionGetCountriesUrl = () => `/api/v1/Region/countries`;

  /**
   * No description
   *
   * @tags Region
   * @name RegionGetCountries
   * @summary Получает список стран
   * @request GET:/api/v1/Region/countries
   * @response `200` `CountriesResponse` Данные о странах
   */
  regionGetCountries<T extends CountriesResponse = CountriesResponse>(params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeRegionGetCountriesUrl(),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for productsGetProductInfo
   */
  composeProductsGetProductInfoUrl = () => `/api/v1/Products/info`;

  /**
   * No description
   *
   * @tags Products
   * @name ProductsGetProductInfo
   * @summary Получает подробную информацию о продукте
   * @request GET:/api/v1/Products/info
   * @response `200` `ProductInfoModel` Информация о продукте
   * @response `400` `ProblemDetails`
   */
  productsGetProductInfo<T extends ProductInfoModel = ProductInfoModel>(
    query?: {
      /**
       * Идентификатор продукта
       * @format int32
       */
      productId?: number;
      /**
       * Идентификатор региона
       * @format int32
       */
      regionId?: number;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeProductsGetProductInfoUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for productsGetProduct
   */
  composeProductsGetProductUrl = () => `/api/v1/Products`;

  /**
   * No description
   *
   * @tags Products
   * @name ProductsGetProduct
   * @summary Получает данные продукта
   * @request GET:/api/v1/Products
   * @response `200` `ProductModel` Данные продукта
   * @response `400` `ProblemDetails`
   */
  productsGetProduct<T extends ProductModel = ProductModel>(
    query?: {
      /**
       * Идентификатор продукта
       * @format int32
       */
      productId?: number;
      /**
       * Идентификатор региона
       * @format int32
       */
      regionId?: number;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeProductsGetProductUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentRegisterDeferredPayment
   */
  composePaymentRegisterDeferredPaymentUrl = () => `/api/v1/Payment/registerdeferred`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentRegisterDeferredPayment
   * @summary Создает новый сценарий отложенной оплаты
   * @request POST:/api/v1/Payment/registerdeferred
   * @response `200` `PaymentRegisterDeferredResponse` Данные оплаты
   * @response `400` `ProblemDetails`
   */
  paymentRegisterDeferredPayment<
    T extends PaymentRegisterDeferredResponse = PaymentRegisterDeferredResponse,
  >(request: RequestModel, params: RequestParams = {}) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentRegisterDeferredPaymentUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentRegisterPayment
   */
  composePaymentRegisterPaymentUrl = () => `/api/v1/Payment/register`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentRegisterPayment
   * @summary Создает новый сценарий оплаты
   * @request POST:/api/v1/Payment/register
   * @response `200` `PaymentRegisterResponse` Данные оплаты
   * @response `400` `ProblemDetails`
   */
  paymentRegisterPayment<T extends PaymentRegisterResponse = PaymentRegisterResponse>(
    request: RequestModel2,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentRegisterPaymentUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentOrderStatus
   */
  composePaymentOrderStatusUrl = () => `/api/v1/Payment/installment/orderStatus`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentOrderStatus
   * @summary Callback-метод статуса по рассрочке
   * @request POST:/api/v1/Payment/installment/orderStatus
   * @response `200` `ResponseModel2` Статус
   * @response `400` `ProblemDetails`
   */
  paymentOrderStatus<T extends ResponseModel2 = ResponseModel2>(
    request: RequestModel3,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentOrderStatusUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentOrderCheck
   */
  composePaymentOrderCheckUrl = (orderNumber: string) =>
    `/api/v1/Payment/installment/${orderNumber}/orderCheck`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentOrderCheck
   * @summary Проверка статуса по рассрочке
   * @request GET:/api/v1/Payment/installment/{orderNumber}/orderCheck
   * @response `200` `ResponseModel3` Статус
   * @response `400` `ProblemDetails`
   */
  paymentOrderCheck<T extends ResponseModel3 = ResponseModel3>(
    orderNumber: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentOrderCheckUrl(orderNumber),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentGetQrCodeImage
   */
  composePaymentGetQrCodeImageUrl = () => `/api/v1/Payment/qrCode`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentGetQrCodeImage
   * @summary Возвращает изображение QR-кода для оплаты
   * @request GET:/api/v1/Payment/qrCode
   * @response `200` `string` Изображение QR-кода
   * @response `400` `ProblemDetails`
   */
  paymentGetQrCodeImage<T extends string = string>(
    query?: {
      /**
       * Идентификатор оплаты
       * @format guid
       */
      paymentId?: string;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentGetQrCodeImageUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentGetPaymentExternalInfo
   */
  composePaymentGetPaymentExternalInfoUrl = () => `/api/v1/Payment/externalInfo`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentGetPaymentExternalInfo
   * @summary Возвращает дополнительные поля оплаты
   * @request GET:/api/v1/Payment/externalInfo
   * @response `200` `ResponseModel4` Дополнительные поля оплаты
   * @response `400` `ProblemDetails`
   */
  paymentGetPaymentExternalInfo<T extends ResponseModel4 = ResponseModel4>(
    query?: {
      /**
       * Идентификатор оплаты
       * @format guid
       */
      paymentId?: string;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentGetPaymentExternalInfoUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentGetGooglePaySettings
   */
  composePaymentGetGooglePaySettingsUrl = () => `/api/v1/Payment/googlePaySettings`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentGetGooglePaySettings
   * @summary Получает настройки GooglePay
   * @request GET:/api/v1/Payment/googlePaySettings
   * @response `200` `ResponseModel5` Настройки
   * @response `400` `ProblemDetails`
   */
  paymentGetGooglePaySettings<T extends ResponseModel5 = ResponseModel5>(
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentGetGooglePaySettingsUrl(),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentGetCardView
   */
  composePaymentGetCardViewUrl = () => `/api/v1/Payment/cardView`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentGetCardView
   * @summary Возвращает страницу для ввода данных карты
   * @request GET:/api/v1/Payment/cardView
   * @response `200` `string` Страница
   * @response `400` `ProblemDetails`
   */
  paymentGetCardView<T extends string = string>(
    query?: {
      /**
       * Идентификатор оплаты
       * @format guid
       */
      paymentId?: string;
      /** Адрес для возврата */
      returnUrl?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentGetCardViewUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentCreateTransaction
   */
  composePaymentCreateTransactionUrl = () => `/api/v1/Payment/transactionCreate`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentCreateTransaction
   * @summary Создает транзакцию
   * @request POST:/api/v1/Payment/transactionCreate
   * @response `200` `PaymentCreateTransactionResponse` Данные транзакции
   * @response `400` `ProblemDetails`
   */
  paymentCreateTransaction<
    T extends PaymentCreateTransactionResponse = PaymentCreateTransactionResponse,
  >(request: RequestModel4, params: RequestParams = {}) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentCreateTransactionUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentCreateApplePaySession
   */
  composePaymentCreateApplePaySessionUrl = () => `/api/v1/Payment/applePaySession`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentCreateApplePaySession
   * @summary Создает сессию ApplePay
   * @request POST:/api/v1/Payment/applePaySession
   * @response `200` `void` Данные сессии
   * @response `400` `ProblemDetails`
   */
  paymentCreateApplePaySession<T extends void = void>(
    query?: {
      /** Адрес */
      url?: string | null;
      /** Сервер */
      host?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentCreateApplePaySessionUrl(),
      method: 'POST',
      query: query,
      ...params,
    });
  }

  /**
   * Generates a request url for paymentCompletePayment
   */
  composePaymentCompletePaymentUrl = () => `/api/v1/Payment/complete`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentCompletePayment
   * @summary Завершает оплату
   * @request POST:/api/v1/Payment/complete
   * @response `200` `ResponseModel6` Данные оплаты
   * @response `400` `ProblemDetails`
   */
  paymentCompletePayment<T extends ResponseModel6 = ResponseModel6>(
    query?: {
      /**
       * Идентификатор оплаты
       * @format guid
       */
      paymentId?: string;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentCompletePaymentUrl(),
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentCheckTransaction
   */
  composePaymentCheckTransactionUrl = () => `/api/v1/Payment/transactionCheck`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentCheckTransaction
   * @summary Проверяет статус транзакции
   * @request GET:/api/v1/Payment/transactionCheck
   * @response `200` `ResponseModel7` Статус транзакции
   * @response `400` `ProblemDetails`
   */
  paymentCheckTransaction<T extends ResponseModel7 = ResponseModel7>(
    query?: {
      /**
       * Идентификатор оплаты
       * @format guid
       */
      paymentId?: string;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentCheckTransactionUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentCheckServiceTransaction
   */
  composePaymentCheckServiceTransactionUrl = () => `/api/v1/Payment/serviceTransactionCheck`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentCheckServiceTransaction
   * @summary Проверяет статус транзакции
   * @request GET:/api/v1/Payment/serviceTransactionCheck
   * @response `200` `CheckServiceTransactionResponseModel` Статус транзакции
   * @response `400` `ProblemDetails`
   */
  paymentCheckServiceTransaction<
    T extends CheckServiceTransactionResponseModel = CheckServiceTransactionResponseModel,
  >(
    query?: {
      /** Слаг провайдера оплаты */
      provider?: string | null;
      /**
       * Идентификатор транзакции
       * @format int64
       */
      transactionId?: number;
      /** Токен транзакции */
      transactionToken?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentCheckServiceTransactionUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentBnplPay
   */
  composePaymentBnplPayUrl = (orderNumber: string) => `/api/v1/Payment/bnpl/${orderNumber}/pay`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentBnplPay
   * @summary Проксирующий метод backoffic'a BnplPay
   * @request POST:/api/v1/Payment/bnpl/{orderNumber}/pay
   * @response `200` `ResponseModel8` Данные для оформления
   * @response `400` `ProblemDetails`
   */
  paymentBnplPay<T extends ResponseModel8 = ResponseModel8>(
    orderNumber: string,
    request: RequestModel5,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentBnplPayUrl(orderNumber),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentBnplPay2
   */
  composePaymentBnplPay2Url = (orderNumber: string) =>
    `/api/v1/Payment/bnpl/${orderNumber}/orderCheck`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentBnplPay2
   * @summary Проксирующий метод backoffic'a BnplPay
   * @request GET:/api/v1/Payment/bnpl/{orderNumber}/orderCheck
   * @response `200` `ResponseModel9` Данные для оформления
   * @response `400` `ProblemDetails`
   */
  paymentBnplPay2<T extends ResponseModel9 = ResponseModel9>(
    orderNumber: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentBnplPay2Url(orderNumber),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for paymentBnplComplete
   */
  composePaymentBnplCompleteUrl = (orderNumber: string) =>
    `/api/v1/Payment/bnpl/${orderNumber}/complete`;

  /**
   * No description
   *
   * @tags Payment
   * @name PaymentBnplComplete
   * @summary Проверка статуса оплаты и завершение заказа в случае завершения оплаты
   * @request GET:/api/v1/Payment/bnpl/{orderNumber}/complete
   * @response `200` `ResponseModel10` Данные для оформления
   * @response `400` `ProblemDetails`
   */
  paymentBnplComplete<T extends ResponseModel10 = ResponseModel10>(
    orderNumber: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composePaymentBnplCompleteUrl(orderNumber),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for orderReserve
   */
  composeOrderReserveUrl = (id: string) => `/api/v1/Order/${id}/reserve`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderReserve
   * @summary Резервирует корзину
   * @request POST:/api/v1/Order/{id}/reserve
   * @response `200` `void`
   */
  orderReserve<T extends void = void>(id: string, params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeOrderReserveUrl(id),
      method: 'POST',
      ...params,
    });
  }

  /**
   * Generates a request url for orderUpdatePayment
   */
  composeOrderUpdatePaymentUrl = (id: string) => `/api/v1/Order/${id}/payment`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderUpdatePayment
   * @summary Обновляет информацию о способе оплаты
   * @request PUT:/api/v1/Order/{id}/payment
   * @response `200` `void`
   */
  orderUpdatePayment<T extends void = void>(
    id: string,
    query?: {
      /** Способ оплаты */
      slug?: string | null;
      /** Обновлять ли только корзину, а заказ нет */
      basketOnly?: boolean | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeOrderUpdatePaymentUrl(id),
      method: 'PUT',
      query: query,
      ...params,
    });
  }

  /**
   * Generates a request url for orderGetPayments
   */
  composeOrderGetPaymentsUrl = (id: string) => `/api/v1/Order/${id}/payments`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderGetPayments
   * @summary Получает доступные способы оплаты
   * @request GET:/api/v1/Order/{id}/payments
   * @response `200` `PaymentsGetResponse` Способы оплаты
   */
  orderGetPayments<T extends PaymentsGetResponse = PaymentsGetResponse>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeOrderGetPaymentsUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for orderGetOrderDoubles
   */
  composeOrderGetOrderDoublesUrl = (orderNumber: string) => `/api/v1/Order/${orderNumber}/doubles`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderGetOrderDoubles
   * @summary Проверяет наличие дубликатов заказа
   * @request GET:/api/v1/Order/{orderNumber}/doubles
   * @response `200` `ResponseModel11` Информация о дубликатах
   * @response `400` `ProblemDetails`
   */
  orderGetOrderDoubles<T extends ResponseModel11 = ResponseModel11>(
    orderNumber: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeOrderGetOrderDoublesUrl(orderNumber),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for orderGetDeferredPaymentOrder
   */
  composeOrderGetDeferredPaymentOrderUrl = (id: string) => `/api/v1/Order/${id}/deferredpayment`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderGetDeferredPaymentOrder
   * @summary Получает отложенную платежную информацию о заказе
   * @request GET:/api/v1/Order/{id}/deferredpayment
   * @response `200` `ResponseModel12` Информация о заказе
   * @response `400` `ProblemDetails`
   */
  orderGetDeferredPaymentOrder<T extends ResponseModel12 = ResponseModel12>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeOrderGetDeferredPaymentOrderUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for orderGetDeferredOrder
   */
  composeOrderGetDeferredOrderUrl = (orderNumber: string) =>
    `/api/v1/Order/${orderNumber}/deferred`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderGetDeferredOrder
   * @summary Получает отложенную информацию о заказе
   * @request GET:/api/v1/Order/{orderNumber}/deferred
   * @response `200` `ResponseModel12` Информация о заказе
   * @response `400` `ProblemDetails`
   */
  orderGetDeferredOrder<T extends ResponseModel12 = ResponseModel12>(
    orderNumber: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeOrderGetDeferredOrderUrl(orderNumber),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for orderGetOrder
   */
  composeOrderGetOrderUrl = (id: string) => `/api/v1/Order/${id}`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderGetOrder
   * @summary Получает информацию о заказе
   * @request GET:/api/v1/Order/{id}
   * @response `200` `ResponseModel12` Информация о заказе
   * @response `400` `ProblemDetails`
   */
  orderGetOrder<T extends ResponseModel12 = ResponseModel12>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeOrderGetOrderUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for orderGetOrder2
   */
  composeOrderGetOrder2Url = () => `/api/v1/Order/list`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderGetOrder2
   * @summary Получает список заказов
   * @request GET:/api/v1/Order/list
   * @response `200` `ResponseModel13` Список заказов
   * @response `400` `ProblemDetails`
   */
  orderGetOrder2<T extends ResponseModel13 = ResponseModel13>(
    query?: {
      /** @format int32 */
      pageSize?: number;
      /** @format int32 */
      page?: number;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeOrderGetOrder2Url(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for orderDolyameWebHook
   */
  composeOrderDolyameWebHookUrl = () => `/api/v1/Order/dolyameWebHook`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderDolyameWebHook
   * @summary Обновляет данные о покупке Dolyame
   * @request POST:/api/v1/Order/dolyameWebHook
   * @response `200` `string` Результат обновления данных
   * @response `400` `ProblemDetails`
   */
  orderDolyameWebHook<T extends string = string>(request: any, params: RequestParams = {}) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeOrderDolyameWebHookUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for orderDolyameCreate
   */
  composeOrderDolyameCreateUrl = (orderNumber: string) =>
    `/api/v1/Order/${orderNumber}/dolyameCreate`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderDolyameCreate
   * @summary Создает транзакцию на покупку Dolyame
   * @request POST:/api/v1/Order/{orderNumber}/dolyameCreate
   * @response `200` `ResponseModel14` Данные для оформления
   * @response `400` `ProblemDetails`
   */
  orderDolyameCreate<T extends ResponseModel14 = ResponseModel14>(
    orderNumber: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeOrderDolyameCreateUrl(orderNumber),
      method: 'POST',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for orderCompleteDeferredOrder
   */
  composeOrderCompleteDeferredOrderUrl = (orderNumber: string) =>
    `/api/v1/Order/${orderNumber}/completedeferred`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderCompleteDeferredOrder
   * @summary Завершает отложенное оформление заказа
   * @request POST:/api/v1/Order/{orderNumber}/completedeferred
   * @response `200` `ResponseModel12` Информация о заказе
   * @response `400` `ProblemDetails`
   */
  orderCompleteDeferredOrder<T extends ResponseModel12 = ResponseModel12>(
    orderNumber: string,
    request: OrderCompleteDeferredRequest,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeOrderCompleteDeferredOrderUrl(orderNumber),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for orderCompleteOrder
   */
  composeOrderCompleteOrderUrl = (id: string) => `/api/v1/Order/${id}/complete`;

  /**
   * No description
   *
   * @tags Order
   * @name OrderCompleteOrder
   * @summary Завершает оформление заказа
   * @request POST:/api/v1/Order/{id}/complete
   * @response `200` `ResponseModel12` Информация о заказе
   * @response `400` `ProblemDetails`
   */
  orderCompleteOrder<T extends ResponseModel12 = ResponseModel12>(
    id: string,
    request: OrderCompleteRequest,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeOrderCompleteOrderUrl(id),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for mobileIdVerify
   */
  composeMobileIdVerifyUrl = () => `/api/v1/MobileId/verify`;

  /**
   * No description
   *
   * @tags MobileId
   * @name MobileIdVerify
   * @summary отправляет запрос на https://mobileid.megafon.ru/verify/ для верификации кода с смс
   * @request GET:/api/v1/MobileId/verify
   * @response `200` `VerifyResponseModel`
   * @response `204` `void`
   * @response `404` `ProblemDetails`
   */
  mobileIdVerify<T extends VerifyResponseModel = VerifyResponseModel>(
    query?: {
      /** значение параметра client_notification_token из ответа метода /si-authorize */
      client_notification_token?: string | null;
      /** четырехзначный код из СМС */
      verify_code?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeMobileIdVerifyUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for mobileIdSendOrderData
   */
  composeMobileIdSendOrderDataUrl = (id: string) => `/api/v1/MobileId/${id}/orderdata`;

  /**
   * No description
   *
   * @tags MobileId
   * @name MobileIdSendOrderData
   * @summary получает пользовательские данные от хоста агрегатора https://aggrmobileid.beeline.ru и отправляет их в бекенд
   * @request PUT:/api/v1/MobileId/{id}/orderdata
   * @response `200` `string` null
   * @response `204` `void` null
   * @response `404` `ProblemDetails`
   */
  mobileIdSendOrderData<T extends string = string>(
    id: string,
    query?: {
      /** уникальный токен, используемый для идентификации оповещения. Формат: GUID */
      client_notification_token?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeMobileIdSendOrderDataUrl(id),
      method: 'PUT',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for mobileIdNotification
   */
  composeMobileIdNotificationUrl = () => `/api/v1/MobileId/notification`;

  /**
   * No description
   *
   * @tags MobileId
   * @name MobileIdNotification
   * @summary данный метод вызывает агрегатор https://aggrmobileid.beeline.ru в ответ на аутентификацию пользователя
   * @request POST:/api/v1/MobileId/notification
   * @response `200` `void`
   */
  mobileIdNotification<T extends void = void>(
    notificationBody: NotificationBodyRequestModel,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeMobileIdNotificationUrl(),
      method: 'POST',
      body: notificationBody,
      type: ContentType.Json,
      ...params,
    });
  }

  /**
   * Generates a request url for mobileIdJwks
   */
  composeMobileIdJwksUrl = () => `/api/v1/MobileId/jwks`;

  /**
   * No description
   *
   * @tags MobileId
   * @name MobileIdJwks
   * @summary формирует jwks токен
   * @request GET:/api/v1/MobileId/jwks
   * @response `200` `any` null
   * @response `204` `void` null
   * @response `404` `ProblemDetails`
   */
  mobileIdJwks<T extends any = any>(params: RequestParams = {}) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeMobileIdJwksUrl(),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for mobileIdGetData
   */
  composeMobileIdGetDataUrl = () => `/api/v1/MobileId/data`;

  /**
   * No description
   *
   * @tags MobileId
   * @name MobileIdGetData
   * @summary получает пользовательские данные от хоста агрегатора https://aggrmobileid.beeline.ru, если пользователь еще не аутентифицирован то возвращает null
   * @request GET:/api/v1/MobileId/data
   * @response `200` `DataResponseModel` null
   * @response `204` `void` null
   * @response `404` `ProblemDetails`
   */
  mobileIdGetData<T extends DataResponseModel = DataResponseModel>(
    query?: {
      /** уникальный токен, используемый для идентификации оповещения. Формат: GUID */
      client_notification_token?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeMobileIdGetDataUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for mobileIdAuthorize
   */
  composeMobileIdAuthorizeUrl = () => `/api/v1/MobileId/authorize`;

  /**
   * No description
   *
   * @tags MobileId
   * @name MobileIdAuthorize
   * @summary отправляет запрос на хост агрегатора https://aggrmobileid.beeline.ru для аутентификации пользователя
   * @request GET:/api/v1/MobileId/authorize
   * @response `200` `AuthorizeResponseModel`
   * @response `204` `void`
   * @response `404` `ProblemDetails`
   */
  mobileIdAuthorize<T extends AuthorizeResponseModel = AuthorizeResponseModel>(
    query?: {
      /** значение для аутентификации абонента. MSISDN. Формат: MSISDN: %MSISDN%, где %MSISDN% - 7nnnNNNnnNN Пример: MSISDN:79663441556 */
      login_hint?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeMobileIdAuthorizeUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for mnpValidateCtnV2
   */
  composeMnpValidateCtnV2Url = () => `/api/v1/Mnp/validate_v2`;

  /**
   * No description
   *
   * @tags Mnp
   * @name MnpValidateCtnV2
   * @summary Проверяет данные телефонного номера для перехода
   * @request POST:/api/v1/Mnp/validate_v2
   * @response `200` `ValidateCtnV2Response` Успешность проверки
   */
  mnpValidateCtnV2<T extends ValidateCtnV2Response = ValidateCtnV2Response>(
    query: ValidateCtnV2Request,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeMnpValidateCtnV2Url(),
      method: 'POST',
      body: query,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for mnpValidateCtn
   */
  composeMnpValidateCtnUrl = () => `/api/v1/Mnp/validate`;

  /**
   * No description
   *
   * @tags Mnp
   * @name MnpValidateCtn
   * @summary Проверяет данные телефонного номера для перехода
   * @request POST:/api/v1/Mnp/validate
   * @response `200` `boolean` Успешность проверки
   * @response `400` `ProblemDetails`
   */
  mnpValidateCtn<T extends boolean = boolean>(
    query: ValidateCtnRequest,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeMnpValidateCtnUrl(),
      method: 'POST',
      body: query,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for mnpGetDefaultTariff
   */
  composeMnpGetDefaultTariffUrl = (region: string) => `/api/v1/Mnp/defaultTariff/${region}`;

  /**
   * No description
   *
   * @tags Mnp
   * @name MnpGetDefaultTariff
   * @summary Получает тариф по умолчанию для перехода
   * @request GET:/api/v1/Mnp/defaultTariff/{region}
   * @response `200` `DefaultTariffResponse` Тариф
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  mnpGetDefaultTariff<T extends DefaultTariffResponse = DefaultTariffResponse>(
    region: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeMnpGetDefaultTariffUrl(region),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for healthCheckGetServiceAvailable
   */
  composeHealthCheckGetServiceAvailableUrl = () => `/api/v1/HealthCheck/serviceavailable`;

  /**
   * No description
   *
   * @tags HealthCheck
   * @name HealthCheckGetServiceAvailable
   * @summary Возвращает данные доступности сервисов
   * @request GET:/api/v1/HealthCheck/serviceavailable
   * @response `200` `string | null` Данные доступности
   */
  healthCheckGetServiceAvailable<T extends string | null = string | null>(
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeHealthCheckGetServiceAvailableUrl(),
      method: 'GET',
      ...params,
    });
  }

  /**
   * Generates a request url for healthCheckGetHeartBeat
   */
  composeHealthCheckGetHeartBeatUrl = () => `/api/v1/HealthCheck/heartbeat`;

  /**
   * No description
   *
   * @tags HealthCheck
   * @name HealthCheckGetHeartBeat
   * @summary Возвращает данные доступности приложения
   * @request GET:/api/v1/HealthCheck/heartbeat
   * @response `200` `string | null` Данные доступности
   */
  healthCheckGetHeartBeat<T extends string | null = string | null>(params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeHealthCheckGetHeartBeatUrl(),
      method: 'GET',
      ...params,
    });
  }

  /**
   * Generates a request url for esiaSendOrderData
   */
  composeEsiaSendOrderDataUrl = (id: string) => `/api/v1/Esia/${id}/orderdata`;

  /**
   * No description
   *
   * @tags Esia
   * @name EsiaSendOrderData
   * @summary Авторизация через Госуслуги (ЕСИА) для абонентов операторов (Part 2 - отправка данных пользователя из ЕСИА после авторизации в бекофис).
   * @request PUT:/api/v1/Esia/{id}/orderdata
   * @response `200` `string` Результат операции
   * @response `204` `void` Результат операции
   * @response `404` `ProblemDetails`
   */
  esiaSendOrderData<T extends string = string>(
    id: string,
    query?: {
      /** Код пользователя, полученный от ЕСИА */
      code?: string | null;
      /** Уникальный идентификатор UUID, отправленный ранее для авторизации пользователя в ЕСИА */
      state?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeEsiaSendOrderDataUrl(id),
      method: 'PUT',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for esiaGetUrl
   */
  composeEsiaGetUrlUrl = () => `/api/v1/Esia/url`;

  /**
   * No description
   *
   * @tags Esia
   * @name EsiaGetUrl
   * @summary Авторизация через Госуслуги (ЕСИА) для абонентов операторов (Part 1 - получение URL ЕСИА для авторизации пользователя).
   * @request GET:/api/v1/Esia/url
   * @response `200` `EsiaUrlResponseModel` Адрес URL для редиректа абонента на ЕСИА с целью прохождения авторизации
   * @response `204` `void` Адрес URL для редиректа абонента на ЕСИА с целью прохождения авторизации
   * @response `404` `ProblemDetails`
   */
  esiaGetUrl<T extends EsiaUrlResponseModel = EsiaUrlResponseModel>(
    query?: {
      /** Адрес URL для редиректа Пользователя после того, как даст разрешение на доступ к данным в ЕСИА */
      redirectUrl?: string | null;
      /** Тип операции, для которой требуется авторизация Пользователя в ЕСИА. По умолчанию запрашивается стандартный набор прав. */
      type?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeEsiaGetUrlUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for esiaGetData
   */
  composeEsiaGetDataUrl = () => `/api/v1/Esia/data`;

  /**
   * No description
   *
   * @tags Esia
   * @name EsiaGetData
   * @summary Авторизация через Госуслуги (ЕСИА) для абонентов операторов (Part 2 - получение данных пользователя из ЕСИА после авторизации).
   * @request GET:/api/v1/Esia/data
   * @response `200` `EsiaDataResponseModel` Модель с данными Пользователя из ЕСИА
   * @response `204` `void` Модель с данными Пользователя из ЕСИА
   * @response `404` `ProblemDetails`
   */
  esiaGetData<T extends EsiaDataResponseModel = EsiaDataResponseModel>(
    query?: {
      /** Код пользователя, полученный от ЕСИА */
      code?: string | null;
      /** Уникальный идентификатор UUID, отправленный ранее для авторизации пользователя в ЕСИА */
      state?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeEsiaGetDataUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for digineticaGetRecommends
   */
  composeDigineticaGetRecommendsUrl = () => `/api/v1/Diginetica/recs`;

  /**
   * No description
   *
   * @tags Diginetica
   * @name DigineticaGetRecommends
   * @summary Получает список рекомендованных продуктов
   * @request POST:/api/v1/Diginetica/recs
   * @response `200` `DigineticaRecommendationsResponseModel` Список продуктов
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  digineticaGetRecommends<
    T extends DigineticaRecommendationsResponseModel = DigineticaRecommendationsResponseModel,
  >(request: DigineticaRecommendationsRequestModel, params: RequestParams = {}) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeDigineticaGetRecommendsUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for addressGetAddress
   */
  composeAddressGetAddressUrl = () => `/api/v1/Address/suggestaddress`;

  /**
   * No description
   *
   * @tags Address
   * @name AddressGetAddress
   * @summary Получает адрес
   * @request GET:/api/v1/Address/suggestaddress
   * @response `200` `AddressResponse` Адрес
   * @response `204` `void` Адрес
   * @response `404` `ProblemDetails`
   */
  addressGetAddress<T extends AddressResponse = AddressResponse>(
    query?: {
      /** Строка поиска */
      query?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeAddressGetAddressUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for addressGetCities
   */
  composeAddressGetCitiesUrl = (query: string) => `/api/v1/Address/city/${query}`;

  /**
   * No description
   *
   * @tags Address
   * @name AddressGetCities
   * @summary Получает список городов
   * @request GET:/api/v1/Address/city/{query}
   * @response `200` `(GetCitiesResult)[]` Список городов
   */
  addressGetCities<T extends GetCitiesResult[] = GetCitiesResult[]>(
    query: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeAddressGetCitiesUrl(query),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for addressGetAddress2Post
   */
  composeAddressGetAddress2PostUrl = () => `/api/v1/Address/street`;

  /**
   * No description
   *
   * @tags Address
   * @name AddressGetAddress2Post
   * @summary Получает список адресов
   * @request POST:/api/v1/Address/street
   * @response `200` `(StreetResponseModel)[]` Список адресов
   */
  addressGetAddress2Post<T extends StreetResponseModel[] = StreetResponseModel[]>(
    query: GetAddressQuery,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeAddressGetAddress2PostUrl(),
      method: 'POST',
      body: query,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for addressGetAddress2Get
   */
  composeAddressGetAddress2GetUrl = () => `/api/v1/Address/cleanaddress`;

  /**
   * No description
   *
   * @tags Address
   * @name AddressGetAddress2Get
   * @summary Получает данные адреса
   * @request GET:/api/v1/Address/cleanaddress
   * @response `200` `AddressResponse` Данные адреса
   * @response `204` `void` Данные адреса
   * @response `404` `ProblemDetails`
   */
  addressGetAddress2Get<T extends AddressResponse = AddressResponse>(
    query?: {
      /** Адрес */
      query?: string | null;
      /** Признак быстрой доставки */
      fastDelivery?: boolean | null;
      /** Номер заказа */
      orderNumber?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeAddressGetAddress2GetUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for ctnGetCtnList
   */
  composeCtnGetCtnListUrl = () => `/api/v1/Ctn/favourite`;

  /**
   * No description
   *
   * @tags Ctn
   * @name CtnGetCtnList
   * @summary Получает список похожих телефонных номеров
   * @request GET:/api/v1/Ctn/favourite
   * @response `200` `FavouriteResponse` Найденные номера
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  ctnGetCtnList<T extends FavouriteResponse = FavouriteResponse>(
    query?: {
      Region?: string | null;
      Number?: string | null;
      NiceClasses?: string | null;
      /** @format int32 */
      DpcId?: number | null;
      Source?: string | null;
      ProductType?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeCtnGetCtnListUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for creditsValidate
   */
  composeCreditsValidateUrl = () => `/api/v1/Credits/validate`;

  /**
   * No description
   *
   * @tags Credits
   * @name CreditsValidate
   * @summary Проверяет данные кредита
   * @request POST:/api/v1/Credits/validate
   * @response `200` `ValidateResponseModel` Результат проверки
   */
  creditsValidate<T extends ValidateResponseModel = ValidateResponseModel>(
    request: ValidateRequestModel,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeCreditsValidateUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for creditsValidateToken
   */
  composeCreditsValidateTokenUrl = () => `/api/v1/Credits/validateToken`;

  /**
   * No description
   *
   * @tags Credits
   * @name CreditsValidateToken
   * @summary Проверяет правильность токена
   * @request POST:/api/v1/Credits/validateToken
   * @response `200` `ValidateTokenResponseModel2` Результат проверки
   */
  creditsValidateToken<T extends ValidateTokenResponseModel2 = ValidateTokenResponseModel2>(
    request: ValidateTokenRequestModel2,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeCreditsValidateTokenUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for creditsSendToken
   */
  composeCreditsSendTokenUrl = () => `/api/v1/Credits/sendToken`;

  /**
   * No description
   *
   * @tags Credits
   * @name CreditsSendToken
   * @summary Отправляет токен для проверки
   * @request POST:/api/v1/Credits/sendToken
   * @response `200` `SendTokenResponseModel2` Результат отправки
   */
  creditsSendToken<T extends SendTokenResponseModel2 = SendTokenResponseModel2>(
    request: SendTokenRequestModel2,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeCreditsSendTokenUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for creditsEnumerateCredits
   */
  composeCreditsEnumerateCreditsUrl = () => `/api/v1/Credits/list`;

  /**
   * No description
   *
   * @tags Credits
   * @name CreditsEnumerateCredits
   * @summary Получает список доступных кредитов
   * @request POST:/api/v1/Credits/list
   * @response `200` `(EnumerateCreditsResponseModel)[]` Список кредитов
   */
  creditsEnumerateCredits<
    T extends EnumerateCreditsResponseModel[] = EnumerateCreditsResponseModel[],
  >(request: EnumerateCreditsRequestModel, params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeCreditsEnumerateCreditsUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for creditsCheck
   */
  composeCreditsCheckUrl = () => `/api/v1/Credits/check`;

  /**
   * No description
   *
   * @tags Credits
   * @name CreditsCheck
   * @summary Проверяет данные по кредиту
   * @request POST:/api/v1/Credits/check
   * @response `200` `CheckResponseModel` Результат проверки
   * @response `429` `ProblemDetails`
   */
  creditsCheck<T extends CheckResponseModel = CheckResponseModel>(
    request: CheckRequestModel,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeCreditsCheckUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for creditsChangeStatus
   */
  composeCreditsChangeStatusUrl = () => `/api/v1/Credits/changeStatus`;

  /**
   * No description
   *
   * @tags Credits
   * @name CreditsChangeStatus
   * @summary Изменяет статус заказа
   * @request POST:/api/v1/Credits/changeStatus
   * @response `200` `ChangeStatusResponseModel`
   */
  creditsChangeStatus<T extends ChangeStatusResponseModel = ChangeStatusResponseModel>(
    request: ChangeStatusRequestModel,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeCreditsChangeStatusUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for clientValidateToken
   */
  composeClientValidateTokenUrl = () => `/api/v1/Client/validateToken`;

  /**
   * No description
   *
   * @tags Client
   * @name ClientValidateToken
   * @summary Проверяет правильность токена
   * @request POST:/api/v1/Client/validateToken
   * @response `200` `ValidateTokenResponseModel3` Результат проверки
   */
  clientValidateToken<T extends ValidateTokenResponseModel3 = ValidateTokenResponseModel3>(
    request: ValidateTokenRequestModel3,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeClientValidateTokenUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for clientSendToken
   */
  composeClientSendTokenUrl = () => `/api/v1/Client/sendToken`;

  /**
   * No description
   *
   * @tags Client
   * @name ClientSendToken
   * @summary Отправляет токен для проверки
   * @request POST:/api/v1/Client/sendToken
   * @response `200` `SendTokenResponseModel3` Результат отправки
   */
  clientSendToken<T extends SendTokenResponseModel3 = SendTokenResponseModel3>(
    request: SendTokenRequestModel3,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeClientSendTokenUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for clientGetMobileOperator
   */
  composeClientGetMobileOperatorUrl = () => `/api/v1/Client/operator`;

  /**
   * No description
   *
   * @tags Client
   * @name ClientGetMobileOperator
   * @summary Получает информацию о мобильном операторе по номеру телефона
   * @request POST:/api/v1/Client/operator
   * @response `200` `ClientOperatorResponseModel`
   */
  clientGetMobileOperator<T extends ClientOperatorResponseModel = ClientOperatorResponseModel>(
    request: OperatorRequestModel,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeClientGetMobileOperatorUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for clientFacSubscriberSearch
   */
  composeClientFacSubscriberSearchUrl = () => `/api/v1/Client/facSubscriberSearch`;

  /**
   * No description
   *
   * @tags Client
   * @name ClientFacSubscriberSearch
   * @summary Получает информацию о номере телефона
   * @request POST:/api/v1/Client/facSubscriberSearch
   * @response `200` `FacSubscriberSearchResponseModel`
   */
  clientFacSubscriberSearch<
    T extends FacSubscriberSearchResponseModel = FacSubscriberSearchResponseModel,
  >(request: FacSubscriberSearchRequestModel, params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeClientFacSubscriberSearchUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for captchaGetImage
   */
  composeCaptchaGetImageUrl = () => `/api/v1/Captcha/image`;

  /**
   * No description
   *
   * @tags Captcha
   * @name CaptchaGetImage
   * @summary Возвращает изображение капчи и проставляет данные сессии
   * @request GET:/api/v1/Captcha/image
   * @response `200` `string` Изображение капчи
   * @response `400` `ProblemDetails`
   */
  captchaGetImage<T extends string = string>(
    query?: {
      /**
       * Ширина
       * @format int32
       */
      w?: number | null;
      /**
       * Высота
       * @format int32
       */
      h?: number | null;
      /** Категория */
      key?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeCaptchaGetImageUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetBasketStats
   */
  composeBasketGetBasketStatsUrl = (basketId: string) => `/api/v1/Basket/${basketId}/stats`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetBasketStats
   * @summary Получает данные статистики по корзине
   * @request GET:/api/v1/Basket/{basketId}/stats
   * @response `200` `BasketStatsResponseModel` Данные статистики
   * @response `204` `void` Данные статистики
   * @response `404` `ProblemDetails`
   */
  basketGetBasketStats<T extends BasketStatsResponseModel = BasketStatsResponseModel>(
    basketId: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketGetBasketStatsUrl(basketId),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetItemServiceList
   */
  composeBasketGetItemServiceListUrl = (id: string, itemId: string) =>
    `/api/v1/Basket/${id}/item/${itemId}/serviceList`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetItemServiceList
   * @summary Получает список доступных услуг для позиции
   * @request GET:/api/v1/Basket/{id}/item/{itemId}/serviceList
   * @response `200` `Record<string,(ResponseService)[]>` Список услуг
   * @response `204` `void` Список услуг
   */
  basketGetItemServiceList<
    T extends Record<string, ResponseService[]> = Record<string, ResponseService[]>,
  >(
    id: string,
    itemId: string,
    query?: {
      /** Фильтрация по артикулам страховок */
      insuranceCodes?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketGetItemServiceListUrl(id, itemId),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketSealBasket
   */
  composeBasketSealBasketUrl = (id: string) => `/api/v1/Basket/${id}/seal`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketSealBasket
   * @summary Запечатывает корзину
   * @request POST:/api/v1/Basket/{id}/seal
   * @response `200` `SealOrderResponse`
   */
  basketSealBasket<T extends SealOrderResponse = SealOrderResponse>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketSealBasketUrl(id),
      method: 'POST',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketSealBasketByOrderNumber
   */
  composeBasketSealBasketByOrderNumberUrl = () => `/api/v1/Basket/sealByOrder`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketSealBasketByOrderNumber
   * @summary Запечатывает корзину
   * @request POST:/api/v1/Basket/sealByOrder
   * @response `200` `SealOrderResponse`
   */
  basketSealBasketByOrderNumber<T extends SealOrderResponse = SealOrderResponse>(
    request: SealOrderRequest,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketSealBasketByOrderNumberUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketPromoCodeRedemption
   */
  composeBasketPromoCodeRedemptionUrl = (basketId: string) =>
    `/api/v1/Basket/${basketId}/promocoderedemption`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketPromoCodeRedemption
   * @summary Погашает промокод в корзине
   * @request PUT:/api/v1/Basket/{basketId}/promocoderedemption
   * @response `200` `PromoCodeRedemptionResponseModel` Результат погашения промокода
   * @response `204` `void` Результат погашения промокода
   * @response `404` `ProblemDetails`
   */
  basketPromoCodeRedemption<
    T extends PromoCodeRedemptionResponseModel = PromoCodeRedemptionResponseModel,
  >(basketId: string, params: RequestParams = {}) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketPromoCodeRedemptionUrl(basketId),
      method: 'PUT',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketDeletePromoCode
   */
  composeBasketDeletePromoCodeUrl = (basketId: string) => `/api/v1/Basket/${basketId}/promocode`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketDeletePromoCode
   * @summary Очищает промокод в корзине
   * @request DELETE:/api/v1/Basket/{basketId}/promocode
   * @response `200` `BasketResponseModel` Состав корзины
   * @response `204` `void` Состав корзины
   * @response `404` `ProblemDetails`
   */
  basketDeletePromoCode<T extends BasketResponseModel = BasketResponseModel>(
    basketId: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketDeletePromoCodeUrl(basketId),
      method: 'DELETE',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketApplyPromoCode
   */
  composeBasketApplyPromoCodeUrl = (basketId: string) => `/api/v1/Basket/${basketId}/promocode`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketApplyPromoCode
   * @summary Применяет промокод в корзине
   * @request PUT:/api/v1/Basket/{basketId}/promocode
   * @response `200` `BasketResponseModel` Состав корзины
   * @response `204` `void` Состав корзины
   * @response `404` `ProblemDetails`
   */
  basketApplyPromoCode<T extends BasketResponseModel = BasketResponseModel>(
    basketId: string,
    request: ApplyPromoCodeRequest,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketApplyPromoCodeUrl(basketId),
      method: 'PUT',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketCreateOrUpdateOrder
   */
  composeBasketCreateOrUpdateOrderUrl = (id: string) => `/api/v1/Basket/order/${id}`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketCreateOrUpdateOrder
   * @summary Создает или обновляет заказ по корзине
   * @request POST:/api/v1/Basket/order/{id}
   * @response `200` `CreateOrUpdateOrderResponseModel` Информация о заказе
   * @response `204` `void` Информация о заказе
   * @response `400` `ProblemDetails`
   */
  basketCreateOrUpdateOrder<
    T extends CreateOrUpdateOrderResponseModel = CreateOrUpdateOrderResponseModel,
  >(id: string, request: CreateOrUpdateOrderRequest, params: RequestParams = {}) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketCreateOrUpdateOrderUrl(id),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketMergeItems
   */
  composeBasketMergeItemsUrl = (id: string) => `/api/v1/Basket/${id}/merge`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketMergeItems
   * @summary Вливает позиции в корзину
   * @request POST:/api/v1/Basket/{id}/merge
   * @response `200` `BasketResponseModel` Состав корзины
   * @response `204` `void` Состав корзины
   */
  basketMergeItems<T extends BasketResponseModel = BasketResponseModel>(
    id: string,
    items: BasketItemRequestModel[],
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketMergeItemsUrl(id),
      method: 'POST',
      body: items,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketMergeBaskets
   */
  composeBasketMergeBasketsUrl = (basketId: string) => `/api/v1/Basket/${basketId}/basketMerge`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketMergeBaskets
   * @summary Вливает несколько корзин в целевую
   * @request PUT:/api/v1/Basket/{basketId}/basketMerge
   * @response `200` `BasketResponseModel` Состав целевой корзины
   * @response `204` `void` Состав целевой корзины
   */
  basketMergeBaskets<T extends BasketResponseModel = BasketResponseModel>(
    basketId: string,
    request: BasketsMergeRequest,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketMergeBasketsUrl(basketId),
      method: 'PUT',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketUpdateLanding
   */
  composeBasketUpdateLandingUrl = (id: string) => `/api/v1/Basket/${id}/landing`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketUpdateLanding
   * @summary Обновляет данные лендинга в корзине
   * @request PUT:/api/v1/Basket/{id}/landing
   * @response `200` `void`
   * @response `204` `void`
   * @response `404` `ProblemDetails`
   */
  basketUpdateLanding<T extends void = void>(
    id: string,
    request: LandingUpdateRequestModel,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketUpdateLandingUrl(id),
      method: 'PUT',
      body: request,
      type: ContentType.Json,
      ...params,
    });
  }

  /**
   * Generates a request url for basketUpdateItem
   */
  composeBasketUpdateItemUrl = (id: string, itemId: string) =>
    `/api/v1/Basket/${id}/item/${itemId}`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketUpdateItem
   * @summary Обновляет данные позиции в корзине
   * @request PUT:/api/v1/Basket/{id}/item/{itemId}
   * @response `200` `BasketResponseModel` Состав корзины
   * @response `204` `void` Состав корзины
   */
  basketUpdateItem<T extends BasketResponseModel = BasketResponseModel>(
    id: string,
    itemId: string,
    item: BasketItemRequestModel,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketUpdateItemUrl(id, itemId),
      method: 'PUT',
      body: item,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketDeleteItem
   */
  composeBasketDeleteItemUrl = (id: string, itemId: string) =>
    `/api/v1/Basket/${id}/item/${itemId}`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketDeleteItem
   * @summary Удаляет позицию из корзины
   * @request DELETE:/api/v1/Basket/{id}/item/{itemId}
   * @response `200` `BasketResponseModel` Состав корзины
   * @response `204` `void` Состав корзины
   */
  basketDeleteItem<T extends BasketResponseModel = BasketResponseModel>(
    id: string,
    itemId: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketDeleteItemUrl(id, itemId),
      method: 'DELETE',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetBasket
   */
  composeBasketGetBasketUrl = (id: string) => `/api/v1/Basket/${id}`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetBasket
   * @summary Получает состав корзины
   * @request GET:/api/v1/Basket/{id}
   * @response `200` `BasketResponseModel` Состав корзины
   * @response `204` `void` Состав корзины
   * @response `404` `ProblemDetails`
   */
  basketGetBasket<T extends BasketResponseModel = BasketResponseModel>(
    id: string,
    query?: {
      /** Метод оплаты */
      paymentMethod?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketGetBasketUrl(id),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketDeleteBasket
   */
  composeBasketDeleteBasketUrl = (id: string) => `/api/v1/Basket/${id}`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketDeleteBasket
   * @summary Удаляет корзину
   * @request DELETE:/api/v1/Basket/{id}
   * @response `200` `void` Факт успешности
   * @response `400` `ProblemDetails`
   */
  basketDeleteBasket<T extends void = void>(id: string, params: RequestParams = {}) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketDeleteBasketUrl(id),
      method: 'DELETE',
      ...params,
    });
  }

  /**
   * Generates a request url for basketAddItems
   */
  composeBasketAddItemsUrl = (id: string) => `/api/v1/Basket/${id}`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketAddItems
   * @summary Добавляет позиции в корзину
   * @request POST:/api/v1/Basket/{id}
   * @response `200` `BasketResponseModel` Состав корзины
   * @response `204` `void` Состав корзины
   */
  basketAddItems<T extends BasketResponseModel = BasketResponseModel>(
    id: string,
    items: BasketItemRequestModel[],
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketAddItemsUrl(id),
      method: 'POST',
      body: items,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDraftBasket
   */
  composeBasketGetDraftBasketUrl = () => `/api/v1/Basket/draft`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDraftBasket
   * @summary Получает данные о корзине для текущего пользователя
   * @request POST:/api/v1/Basket/draft
   * @response `200` `ResponseModel15` Данные о корзине
   */
  basketGetDraftBasket<T extends ResponseModel15 = ResponseModel15>(params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDraftBasketUrl(),
      method: 'POST',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketUpdateDelivery
   */
  composeBasketUpdateDeliveryUrl = (id: string) => `/api/v1/Basket/${id}/delivery`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketUpdateDelivery
   * @summary Обновляет информацию о способе доставки
   * @request PUT:/api/v1/Basket/{id}/delivery
   * @response `200` `DeliveryUpdateOrderCommandResult`
   */
  basketUpdateDelivery<
    T extends DeliveryUpdateOrderCommandResult = DeliveryUpdateOrderCommandResult,
  >(
    id: string,
    data: DeliveryUpdateModel,
    query?: {
      /** Обновлять ли только корзину, а заказ нет */
      basketOnly?: boolean | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketUpdateDeliveryUrl(id),
      method: 'PUT',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDelivery
   */
  composeBasketGetDeliveryUrl = (id: string) => `/api/v1/Basket/${id}/delivery`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDelivery
   * @summary Получает информацию о доставке
   * @request GET:/api/v1/Basket/{id}/delivery
   * @response `200` `DeliveryGetModel` Информация о доставке
   */
  basketGetDelivery<T extends DeliveryGetModel = DeliveryGetModel>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDeliveryUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDeliveryRoutes
   */
  composeBasketGetDeliveryRoutesUrl = (id: string) => `/api/v1/Basket/${id}/routes`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDeliveryRoutes
   * @summary Получает информацию и маршрутах доставки
   * @request GET:/api/v1/Basket/{id}/routes
   * @response `200` `DeliveryRouteDeliveryModel` Информация о маршрутах доставки
   */
  basketGetDeliveryRoutes<T extends DeliveryRouteDeliveryModel = DeliveryRouteDeliveryModel>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDeliveryRoutesUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDeliveryRoutesV2
   */
  composeBasketGetDeliveryRoutesV2Url = (id: string) => `/api/v1/Basket/${id}/routes_v2`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDeliveryRoutesV2
   * @summary Получает информацию и маршрутах доставки
   * @request GET:/api/v1/Basket/{id}/routes_v2
   * @response `200` `DeliveryRouteDeliveryV2Model` Информация о маршрутах доставки
   */
  basketGetDeliveryRoutesV2<T extends DeliveryRouteDeliveryV2Model = DeliveryRouteDeliveryV2Model>(
    id: string,
    query?: {
      /**
       * Id города
       * @format int32
       */
      cityId?: number;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDeliveryRoutesV2Url(id),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDeliveryPvzPostamats
   */
  composeBasketGetDeliveryPvzPostamatsUrl = (id: string) => `/api/v1/Basket/${id}/pvz_postamat`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDeliveryPvzPostamats
   * @summary Получает информацию о постоматах
   * @request GET:/api/v1/Basket/{id}/pvz_postamat
   * @response `200` `(DeliveryPvzPostomatModel)[]` Постоматы
   */
  basketGetDeliveryPvzPostamats<T extends DeliveryPvzPostomatModel[] = DeliveryPvzPostomatModel[]>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDeliveryPvzPostamatsUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDeliveryPoints
   */
  composeBasketGetDeliveryPointsUrl = (id: string) => `/api/v1/Basket/${id}/points`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDeliveryPoints
   * @summary Получает информацию о точках самовывоза
   * @request GET:/api/v1/Basket/{id}/points
   * @response `200` `(DeliveryPointModel)[]` Точки самовывоза
   */
  basketGetDeliveryPoints<T extends DeliveryPointModel[] = DeliveryPointModel[]>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDeliveryPointsUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDeliveryMovementPoints
   */
  composeBasketGetDeliveryMovementPointsUrl = (id: string) =>
    `/api/v1/Basket/${id}/movement_points`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDeliveryMovementPoints
   * @summary Получает информацию о перемещениях
   * @request GET:/api/v1/Basket/{id}/movement_points
   * @response `200` `(DeliveryPointMovementModel)[]` Перемещения
   */
  basketGetDeliveryMovementPoints<
    T extends DeliveryPointMovementModel[] = DeliveryPointMovementModel[],
  >(id: string, params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDeliveryMovementPointsUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDeliveryMovementV2Points
   */
  composeBasketGetDeliveryMovementV2PointsUrl = (id: string) =>
    `/api/v1/Basket/${id}/movement_v2_points`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDeliveryMovementV2Points
   * @summary Получает информацию о перемещениях
   * @request GET:/api/v1/Basket/{id}/movement_v2_points
   * @response `200` `(DeliveryPointMovementModel)[]` Перемещения
   */
  basketGetDeliveryMovementV2Points<
    T extends DeliveryPointMovementModel[] = DeliveryPointMovementModel[],
  >(id: string, params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDeliveryMovementV2PointsUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDeliveryFranchisePoint
   */
  composeBasketGetDeliveryFranchisePointUrl = (id: string) =>
    `/api/v1/Basket/${id}/franchise_points`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDeliveryFranchisePoint
   * @summary Получает информацию о партнерских точках
   * @request GET:/api/v1/Basket/{id}/franchise_points
   * @response `200` `(DeliveryPointFranchiseModel)[]` Партнерские точки
   */
  basketGetDeliveryFranchisePoint<
    T extends DeliveryPointFranchiseModel[] = DeliveryPointFranchiseModel[],
  >(id: string, params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDeliveryFranchisePointUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDeliveryOnline
   */
  composeBasketGetDeliveryOnlineUrl = (id: string) => `/api/v1/Basket/${id}/online_delivery`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDeliveryOnline
   * @summary Получает информацию об онлайн доставке
   * @request GET:/api/v1/Basket/{id}/online_delivery
   * @response `200` `DeliveryOnlineDeliveryModel` Информация об онлайн доставке
   */
  basketGetDeliveryOnline<T extends DeliveryOnlineDeliveryModel = DeliveryOnlineDeliveryModel>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDeliveryOnlineUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetFastDeliveryStreets
   */
  composeBasketGetFastDeliveryStreetsUrl = () => `/api/v1/Basket/fast_delivery_streets`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetFastDeliveryStreets
   * @summary Поиска активных улиц Быстрой доставки
   * @request GET:/api/v1/Basket/fast_delivery_streets
   * @response `200` `(ResponseFastDeliveryStreet)[]` Улицы быстрой доставки
   */
  basketGetFastDeliveryStreets<
    T extends ResponseFastDeliveryStreet[] = ResponseFastDeliveryStreet[],
  >(
    query?: {
      /** город доставки */
      cityId?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketGetFastDeliveryStreetsUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetFastDeliveryCities
   */
  composeBasketGetFastDeliveryCitiesUrl = () => `/api/v1/Basket/fast_delivery_cities`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetFastDeliveryCities
   * @summary Поиск городов быстрой доставки
   * @request GET:/api/v1/Basket/fast_delivery_cities
   * @response `200` `FastDeliveryCitiesResponse` Города быстрой доставки
   */
  basketGetFastDeliveryCities<T extends FastDeliveryCitiesResponse = FastDeliveryCitiesResponse>(
    query?: {
      /**
       * Идентификатор региона
       * @format int32
       */
      marketRegion?: number;
      /** Запрос для поиска */
      search?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketGetFastDeliveryCitiesUrl(),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDeliveryFastMovementPoints
   */
  composeBasketGetDeliveryFastMovementPointsUrl = (id: string) =>
    `/api/v1/Basket/${id}/fast_movement_points`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDeliveryFastMovementPoints
   * @summary Возвращает список точек для быстрого перемещения
   * @request GET:/api/v1/Basket/{id}/fast_movement_points
   * @response `200` `(DeliveryFastPointMovementModel)[]` Перемещения
   */
  basketGetDeliveryFastMovementPoints<
    T extends DeliveryFastPointMovementModel[] = DeliveryFastPointMovementModel[],
  >(id: string, params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDeliveryFastMovementPointsUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetDeliveryFast
   */
  composeBasketGetDeliveryFastUrl = (id: string) => `/api/v1/Basket/${id}/fast_delivery`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetDeliveryFast
   * @summary Получает информацию о быстрой доставке
   * @request GET:/api/v1/Basket/{id}/fast_delivery
   * @response `200` `DeliveryFastDeliveryModel` Информация о быстрой доставке
   */
  basketGetDeliveryFast<T extends DeliveryFastDeliveryModel = DeliveryFastDeliveryModel>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketGetDeliveryFastUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetEmployeeDelivery
   */
  composeBasketGetEmployeeDeliveryUrl = (id: string) => `/api/v1/Basket/${id}/employee_delivery`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetEmployeeDelivery
   * @summary Получает информацию о доставке сотрудниками
   * @request GET:/api/v1/Basket/{id}/employee_delivery
   * @response `200` `DeliveryIntervalsPerDateModel` Информация о доставке сотрудниками
   */
  basketGetEmployeeDelivery<
    T extends DeliveryIntervalsPerDateModel = DeliveryIntervalsPerDateModel,
  >(id: string, params: RequestParams = {}) {
    return this.http.request<T, any>({
      path: this.composeBasketGetEmployeeDeliveryUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetCtnList
   */
  composeBasketGetCtnListUrl = (regionIdOrPath: string) =>
    `/api/v1/Basket/ctnList/${regionIdOrPath}`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetCtnList
   * @summary Возвращает список доступных номеров телефонов
   * @request GET:/api/v1/Basket/ctnList/{regionIdOrPath}
   * @response `200` `FetchCtnByRuleResponse` Список номеров
   * @response `400` `ProblemDetails`
   */
  basketGetCtnList<T extends FetchCtnByRuleResponse = FetchCtnByRuleResponse>(
    regionIdOrPath: string,
    query?: {
      /**
       * DpcId тарифа, для которого производится получение номеров
       * @format int32
       */
      dpcId?: number | null;
      /** Источник тарифа, для которого производится получение номеров */
      source?: string | null;
      /** Тип номера */
      productType?: string | null;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketGetCtnListUrl(regionIdOrPath),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketCreateBasket
   */
  composeBasketCreateBasketUrl = () => `/api/v1/Basket`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketCreateBasket
   * @summary Создает новую корзину
   * @request POST:/api/v1/Basket
   * @response `200` `BasketResponseModel` Состав корзины
   * @response `204` `void` Состав корзины
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   */
  basketCreateBasket<T extends BasketResponseModel = BasketResponseModel>(
    request: RequestModel6,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketCreateBasketUrl(),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketCopyOrderBasket
   */
  composeBasketCopyOrderBasketUrl = (orderHash: string) => `/api/v1/Basket/${orderHash}/copyorder`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketCopyOrderBasket
   * @summary Создаёт копию корзины на основе хэша номера заказа
   * @request PUT:/api/v1/Basket/{orderHash}/copyorder
   * @response `200` `BasketResponseModel` Состав корзины
   * @response `204` `void` Состав корзины
   */
  basketCopyOrderBasket<T extends BasketResponseModel = BasketResponseModel>(
    orderHash: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketCopyOrderBasketUrl(orderHash),
      method: 'PUT',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketUpdateClientInfo
   */
  composeBasketUpdateClientInfoUrl = (id: string) => `/api/v1/Basket/${id}/client`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketUpdateClientInfo
   * @summary Обновляет клиентскую информацию корзины
   * @request PUT:/api/v1/Basket/{id}/client
   * @response `200` `void`
   */
  basketUpdateClientInfo<T extends void = void>(
    id: string,
    request: RequestModel7,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketUpdateClientInfoUrl(id),
      method: 'PUT',
      body: request,
      type: ContentType.Json,
      ...params,
    });
  }

  /**
   * Generates a request url for basketUpdateRegion
   */
  composeBasketUpdateRegionUrl = (basketId: string) => `/api/v1/Basket/${basketId}/region`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketUpdateRegion
   * @summary Изменяет регион корзины
   * @request PUT:/api/v1/Basket/{basketId}/region
   * @response `200` `BasketResponseModel` Состав корзины
   * @response `204` `void` Состав корзины
   * @response `404` `ProblemDetails`
   */
  basketUpdateRegion<T extends BasketResponseModel = BasketResponseModel>(
    basketId: string,
    request: ChangeRegionRequest,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketUpdateRegionUrl(basketId),
      method: 'PUT',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetBnpl
   */
  composeBasketGetBnplUrl = (id: string) => `/api/v1/Basket/bnpl/${id}`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetBnpl
   * @summary Получает информацию о BNPL
   * @request GET:/api/v1/Basket/bnpl/{id}
   * @response `200` `ResponseModel16` Информация о заказе
   * @response `400` `ProblemDetails`
   */
  basketGetBnpl<T extends ResponseModel16 = ResponseModel16>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketGetBnplUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetBaseCityRoutesV2
   */
  composeBasketGetBaseCityRoutesV2Url = (id: string) => `/api/v1/Basket/${id}/base_city_routes_v2`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetBaseCityRoutesV2
   * @summary Получение города с наибольшим показателем веса (таблица geo_city, столбец weight) в своем маркет регионе
   * @request GET:/api/v1/Basket/{id}/base_city_routes_v2
   * @response `200` `BaseCityRoutesV2Response` id города наиболее значимого (по показателю веса weight) в запрашиваемом регионе
   * @response `404` `ProblemDetails`
   */
  basketGetBaseCityRoutesV2<T extends BaseCityRoutesV2Response = BaseCityRoutesV2Response>(
    id: string,
    query?: {
      /**
       * id маркетингового региона
       * @format int32
       */
      marketId?: number;
    },
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketGetBaseCityRoutesV2Url(id),
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketGetArmorJacks
   */
  composeBasketGetArmorJacksUrl = (id: string) => `/api/v1/Basket/${id}/armorjackinfo`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketGetArmorJacks
   * @summary Получает информацию о ArmorJack в зависимости от категорий товаров в корзине
   * @request GET:/api/v1/Basket/{id}/armorjackinfo
   * @response `200` `(BasketItemBaseModel)[]` Список ArmorJack
   */
  basketGetArmorJacks<T extends BasketItemBaseModel[] = BasketItemBaseModel[]>(
    id: string,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketGetArmorJacksUrl(id),
      method: 'GET',
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketAdjustBasket
   */
  composeBasketAdjustBasketUrl = (id: string) => `/api/v1/Basket/${id}/adjust`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketAdjustBasket
   * @summary Модифицирует корзину для соответствия параметрам
   * @request POST:/api/v1/Basket/{id}/adjust
   * @response `200` `ResponseModel17` Ответ
   * @response `404` `ProblemDetails`
   */
  basketAdjustBasket<T extends ResponseModel17 = ResponseModel17>(
    id: string,
    request: RequestModel8,
    params: RequestParams = {},
  ) {
    return this.http.request<T, ProblemDetails>({
      path: this.composeBasketAdjustBasketUrl(id),
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }

  /**
   * Generates a request url for basketAddItems2
   */
  composeBasketAddItems2Url = (basketId: string) => `/api/v1/Basket/${basketId}/ctn`;

  /**
   * No description
   *
   * @tags Basket
   * @name BasketAddItems2
   * @summary Добавляет в корзину позицию с номером телефона
   * @request POST:/api/v1/Basket/{basketId}/ctn
   * @response `200` `BasketResponseModel`
   * @response `201` `void` Состав корзины
   * @response `204` `void` Состав корзины
   */
  basketAddItems2<T extends BasketResponseModel = BasketResponseModel>(
    basketId: string,
    ctn: AddCtnRequest,
    params: RequestParams = {},
  ) {
    return this.http.request<T, any>({
      path: this.composeBasketAddItems2Url(basketId),
      method: 'POST',
      body: ctn,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  }
}
